<script setup lang="ts">
import { type Payment } from '@/api/payments';
import { formatCurrency } from '@/utils/currency';

// Phone rendering of a /payments row: tap the body to open the payment detail;
// the icon row mirrors the desktop per-row actions.
interface Props {
  payment: Payment;
  // payments/show: the PDF and the WhatsApp link both hand out the document.
  canShowDocument?: boolean;
}

withDefaults(defineProps<Props>(), { canShowDocument: true });

const emit = defineEmits<{
  open: [];
  pdf: [];
  email: [];
  whatsapp: [];
}>();
</script>
<template>
  <v-card
    v-ripple
    variant="elevated"
    :elevation="1"
    class="pa-3"
    @click="emit('open')"
  >
    <div class="d-flex align-center ga-2">
      <span class="font-weight-bold text-body-1 text-truncate flex-grow-1">
        {{ payment.caregiver.fullName }}
      </span>
      <v-chip
        color="grey-darken-3"
        size="small"
        class="flex-shrink-0"
      >
        {{ formatCurrency(payment.amountPendingToPay) }}
      </v-chip>
    </div>
    <div class="d-flex flex-wrap ga-4 mt-2 text-body-2">
      <span>
        <span class="text-medium-emphasis">Turnos:</span> {{ payment.shiftsCount }}
      </span>
      <span>
        <span class="text-medium-emphasis">Bruto:</span> {{ formatCurrency(payment.totalCost) }}
      </span>
      <span>
        <span class="text-medium-emphasis">Líquido:</span> {{ formatCurrency(payment.cost) }}
      </span>
      <span v-if="payment.totalPaymentMovements">
        <span class="text-medium-emphasis">Ajustes:</span> {{ formatCurrency(payment.totalPaymentMovements) }}
      </span>
    </div>
    <div class="d-flex justify-end ga-1 mt-1">
      <v-btn
        v-if="canShowDocument"
        icon="mdi-printer"
        size="small"
        variant="text"
        density="comfortable"
        @click.stop="emit('pdf')"
      />
      <v-btn
        v-if="payment.caregiver.email"
        icon="mdi-email-arrow-right"
        size="small"
        variant="text"
        density="comfortable"
        @click.stop="emit('email')"
      />
      <v-btn
        v-if="canShowDocument && payment.caregiver.phoneNumber"
        icon="mdi-whatsapp"
        size="small"
        variant="text"
        density="comfortable"
        @click.stop="emit('whatsapp')"
      />
    </div>
  </v-card>
</template>
